import React from 'react';
export function InnerTruthSection() {
  return <section className="py-20 bg-gradient-to-b from-[#0a0a0a] to-[#111] relative overflow-hidden" data-id="element-118">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-amber-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-119"></div>

      <div className="max-w-6xl mx-auto px-5 md:px-8 relative z-10" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <h2 className="text-3xl md:text-5xl font-poppins font-bold text-white mb-6 leading-tight" data-id="element-122">
            Por eso nace{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-amber-600" data-id="element-123">
              Libro de la Sabiduría
            </span>
          </h2>
          <p className="text-xl text-amber-500 font-medium tracking-wide uppercase" data-id="element-124">
            Una Guía Simbólica de la Conciencia
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center mb-20" data-id="element-125">
          <div className="lg:w-1/2 relative" data-id="element-126">
            <div className="absolute inset-0 bg-gradient-to-tr from-amber-500/20 to-transparent rounded-2xl blur-xl" data-id="element-127"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qvmPyjrZZNx4JaMnUbtsNR/TSL.png" alt="Conciencia y Chakras" className="w-full h-auto rounded-2xl shadow-[0_0_30px_rgba(245,158,11,0.15)] border border-white/5 relative z-10" data-id="element-128" />
          </div>

          <div className="lg:w-1/2 space-y-6 text-gray-300 text-lg font-light" data-id="element-129">
            <p data-id="element-130">
              Un ebook profundo, visual y fácil de recorrer, creado para
              ayudarte a mirar hacia adentro con más claridad y comprender los
              símbolos que conectan mente, cuerpo, energía y espíritu.
            </p>
            <p className="text-white font-medium border-l-2 border-amber-500 pl-4 py-1" data-id="element-131">
              No para que creas ciegamente. Sino para que observes. Para que
              reflexiones.
            </p>
            <p data-id="element-132">
              Para que empieces a reconocer el lenguaje silencioso de tu mundo
              interior.
            </p>
            <p data-id="element-133">
              Porque algo dentro de ti ya sabe que los símbolos no son simples
              dibujos.
            </p>
            <p className="text-amber-400 font-medium" data-id="element-134">
              Son puertas. Son mapas. Son recordatorios de una sabiduría que
              muchas veces permanece dormida bajo el ruido de la vida diaria.
            </p>
          </div>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl backdrop-blur-sm relative overflow-hidden" data-id="element-135">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-[80px]" data-id="element-136"></div>

          <h3 className="text-2xl md:text-3xl font-poppins font-bold text-center text-white mb-10" data-id="element-137">
            Dentro de este libro descubrirás:
          </h3>

          <div className="grid md:grid-cols-2 gap-6 relative z-10" data-id="element-138">
            {[{
            title: 'La luz',
            desc: 'como principio de conciencia.'
          }, {
            title: 'El ser humano',
            desc: 'como microcosmos.'
          }, {
            title: 'La energía vital',
            desc: 'como fuerza de transformación interior.'
          }, {
            title: 'La glándula pineal',
            desc: 'como símbolo de intuición y percepción profunda.'
          }, {
            title: 'Los chakras',
            desc: 'como mapa emocional del cuerpo y la conciencia.'
          }, {
            title: 'Los símbolos, sigilos y geometría sagrada',
            desc: 'como lenguaje visual del alma.'
          }].map((item, idx) => <div key={idx} className="flex items-start bg-black/40 p-5 rounded-xl border border-white/5 hover:border-amber-500/30 transition-colors" data-id="element-139">
                <span className="text-amber-500 text-xl mr-4 mt-1" data-id="element-140">✧</span>
                <div data-id="element-141">
                  <h4 className="text-white font-bold" data-id="element-142">{item.title}</h4>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-143">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="mt-20 text-center max-w-3xl mx-auto space-y-6 text-gray-300 text-lg font-light" data-id="element-144">
          <p data-id="element-145">
            Y mientras avanzas por sus páginas, puede que empieces a notar algo.
          </p>
          <p data-id="element-146">
            No como una revelación forzada. Sino como una comprensión tranquila.
          </p>
          <p className="text-white font-medium" data-id="element-147">
            Una sensación de orden. Como si algunas piezas internas comenzaran a
            encontrar su lugar.
          </p>
          <p data-id="element-148">
            Este libro no es un dogma. No es una promesa mágica. No pretende
            decirte qué creer.
          </p>
          <p data-id="element-149">
            Es una guía simbólica para ayudarte a ordenar lo que quizá ya venías
            sintiendo desde hace tiempo.
          </p>

          <div className="py-6" data-id="element-150">
            <h3 className="text-2xl md:text-3xl font-poppins font-bold text-amber-500 mb-4" data-id="element-151">
              Porque tal vez no estás perdido. Tal vez solo te faltaba un mapa.
            </h3>
            <p className="text-xl text-white" data-id="element-152">
              Y cuando empiezas a ver tu mundo interior como un mapa, algo
              cambia.
            </p>
          </div>

          <p data-id="element-153">
            La confusión se convierte en curiosidad. La búsqueda se vuelve más
            clara.
          </p>
          <p className="text-amber-400 font-medium text-xl" data-id="element-154">
            Y esa sensación de estar desconectado empieza a transformarse en una
            conexión más profunda contigo mismo.
          </p>

          <div className="pt-10" data-id="element-155">
            <a href="#comprar" className="inline-flex items-center justify-center bg-gradient-to-r from-amber-500 to-amber-700 hover:from-amber-400 hover:to-amber-600 text-black font-bold px-8 py-4 rounded-full text-lg transition-all duration-300 shadow-[0_0_20px_rgba(245,158,11,0.4)] transform hover:scale-105 active:scale-95 uppercase tracking-wide" data-id="element-156">
              Quiero mi mapa interior
            </a>
          </div>
        </div>
      </div>
    </section>;
}